/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';

/*
 * Defines the Design Language System (DLS) Wheel Hub Icon component.
 */
export const WheelHubIcon = ({size = 31, color = dlsColor('grey3')}: {size?: number; color?: string}) => {
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill='none'>
      <circle cx='15.5' cy='15.5' r='14.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='15.5' cy='15.5' r='10.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='22.5' cy='15.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='8.5' cy='15.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='15.5' cy='8.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='20.5' cy='10.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='10.5' cy='10.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='20.5' cy='20.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='10.5' cy='20.5' r='0.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='15.5' cy='15.5' r='3.75' stroke={color} strokeWidth='1.5'/>
      <circle cx='15.5' cy='22.5' r='0.75' stroke={color} strokeWidth='1.5'/>
    </svg>
  );
};

export default WheelHubIcon;
